export const theme = {
  colors: {
    primary: '#B2802D', // Highlight color
    background: '#0a192f', // Dark background color
    text: '#E8CB78', // Light text color
  },
};
